/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Titulo_Contactos_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: sCell ? 42 : 48, fontWeight: 800, color: theme.palette.primary.main}}>
                    Contactos
                </Typography>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: sCell ? 18 : 20, lineHeight: 1.3}}>
                    Somos una institución privada con sentido social que presta servicios de salud y seguridad en el
                    trabajo, apoyando al sector empresarial privado y público.
                </Typography>
            </Grid2>

        </Grid2>
    )

}
export default Titulo_Contactos_Home;